import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';

import { MatValidateAddressDirective } from './directives/address-validator/mat-address-validator.directive';
import { MatGoogleMapsAutocompleteDirective } from './directives/mat-google-maps-autocomplete.directive';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatGoogleMapsAutocompleteDirective,
    MatValidateAddressDirective,
  ],
  exports: [MatGoogleMapsAutocompleteDirective, MatValidateAddressDirective],
})
export class MatGoogleMapsAutocompleteModule {
  static forRoot(): ModuleWithProviders<MatGoogleMapsAutocompleteModule> {
    return {
      ngModule: MatGoogleMapsAutocompleteModule,
      providers: [],
    };
  }
}
